import { HttpError, isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import { INTEGRATION_KEY } from "../integration/Constants"
import { Metadata } from "./metadata"
import { Payin, PayinConfig, PayinConfigDto, PayinDto } from "./rainforest/Payin"

class PaymentProcessorService {
    static payinConfigHttpClient: HttpClient<PayinConfig, PayinConfigDto> = new HttpClient<PayinConfig, PayinConfigDto>(PayinConfig)
    static payinHttpClient: HttpClient<Payin, PayinDto> = new HttpClient<Payin, PayinDto>(Payin)

    static async createPayinConfig(
        amount: number,
        merchantId: string, 
        cardholderName: string,
        metadata: Metadata, 
        integrationKey: INTEGRATION_KEY,
    ): Promise<PayinConfig | HttpError> {
        const paymentConfigPayload = {"amount": amount, "merchantId": merchantId, "metaData": metadata, "cardholderName": cardholderName}
        const resPayinConfig = await this.payinConfigHttpClient.post(`/${integrationKey}/payment-configs`, paymentConfigPayload)
        if (isError(resPayinConfig)) {
            return resPayinConfig as HttpError
        }

        return resPayinConfig as PayinConfig
    }

    static async presentPayinConfig(
        payinConfigId: string,
        terminalId: string,
    ): Promise<Payin | HttpError> {
        const resPayin = await this.payinHttpClient.post(
            `/terminals/${terminalId}/present`,
            {"payinConfigId": payinConfigId}
        )
        if (isError(resPayin)) {
            return resPayin as HttpError
        }

        return resPayin as Payin
    }

    static async cancelPayin(terminalId: string): Promise<Payin | HttpError> {
        const resPayin = await this.payinHttpClient.post(
            `/terminals/${terminalId}/cancel`,
            {}
        )
        if (isError(resPayin)) {
            return resPayin as HttpError
        }

        return resPayin as Payin
    }

    static cancelPayinBeacon(terminalId: string): void {
        navigator.sendBeacon(`/api/terminals/${terminalId}/cancel`)
    }

    static async getPayin(
        payinId: string,
        merchantId: string,
        integrationKey: INTEGRATION_KEY
    ): Promise<Payin | HttpError> {
        const resPayin = await this.payinHttpClient.get(`/${integrationKey}/merchants/${merchantId}/payment-configs/${payinId}`)
        if (isError(resPayin)) {
            return resPayin as HttpError
        }

        return resPayin as Payin
    }
}

export default PaymentProcessorService


// WEBPACK FOOTER //
// ./src/state/payment-processor/paymentProcessorService.ts